import DE from './translations/de';
import TR from './translations/tr';
import EN from './translations/en';
export default {
    DE,
    TR,
    EN
};
